import { useEffect, useState } from 'react';

// Re-renders the caller every `stepMs` so running timers count up. The pages
// that use it (dashboard, project detail, run) re-render whole, so ticking while
// nobody can see them is pure waste — an installed app left open in the
// background kept the CPU busy all day. While hidden the interval is stopped;
// on return one tick fires right away so the numbers aren't stale for a second.
export const useTicker = (stepMs = 1000): number => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let id: number | undefined;
    const bump = () => setTick((current) => current + 1);

    const start = () => {
      if (id === undefined) {
        id = window.setInterval(bump, stepMs);
      }
    };
    const stop = () => {
      if (id !== undefined) {
        window.clearInterval(id);
        id = undefined;
      }
    };
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') {
        stop();
      } else {
        bump();
        start();
      }
    };

    if (document.visibilityState !== 'hidden') {
      start();
    }
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [stepMs]);

  return tick;
};
